import { Survey } from '../api';

export class SurveyRequestGET {
  readonly method: string = 'survey';
  public buildURL(email: string) {
    let baseURL = process.env.REACT_APP_API_SURVEY_URL;
    return `${baseURL}/${this.method}?email=${email}`;
  }
  public generateConfig() {
    return {
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
      },
    };
  }
}

export type SurveyResponseGET = {
  status: string;
  message?: string;
  data: Survey;
};
